import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Icon } from '@codex-brightworld/icons';

const Link = styled.a`
  display: block;
  width: ${props => (props.width === undefined ? 'auto' : `${props.width}px`)};
  height: ${props => (props.height === undefined ? 'auto' : `${props.height}px`)};
`;

const Img = styled.img.attrs(props => ({ 'data-qa': props.qa }))`
  display: block;
  width: ${props => props.width};
  height: ${props => props.height};
`;

const LoaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${props => (props.width === undefined ? 'auto' : `${props.width}px`)};
  height: ${props => (props.height === undefined ? 'auto' : `${props.height}px`)};
`;

const Loader = styled(Icon).attrs({ icon: 'loading', spin: true })`
  width: 30px;
  height: 30px;
  color: ${props => props.theme.colors.shades[4]};
`;

class Image extends PureComponent {

  state = {
    loaded: false
  };

  componentDidMount() {
    const { props } = this;

    if (props.lazy && typeof document !== 'undefined') {
      const newImage = document.createElement('img');

      newImage.src = this.props.image;

      newImage.onload = () => {
        this.setState({ loaded: true });
      };
    }
  }

  render() {
    const { props, state } = this;

    const output = props.lazy && !state.loaded
      ? (
        <LoaderWrapper
          width={props.width}
          height={props.height}
          className={!props.link ? props.className : undefined}
        >
          <Loader />
        </LoaderWrapper>
      )
      : (
        <Img
          src={props.image}
          alt={props.title}
          width={props.link || props.width === undefined ? '100%' : `${props.width}px`}
          height={props.link || props.height === undefined ? '100%' : `${props.height}px`}
          data-qa={props.qa}
          className={!props.link ? props.className : undefined}
        />
      );

    if (props.link) {
      return (
        <Link
          className={props.className}
          href={props.link}
          width={props.width}
          height={props.height}
        >
          {output}
        </Link>
      );
    }

    return output;
  }
}

Image.propTypes = {
  alt: PropTypes.string,
  height: PropTypes.number,
  image: PropTypes.string,
  lazy: PropTypes.bool,
  link: PropTypes.string,
  width: PropTypes.number,
  qa: PropTypes.string,
  className: PropTypes.string
};

Image.defaultProps = {
  alt: undefined,
  height: undefined,
  image: undefined,
  lazy: false,
  link: undefined,
  width: undefined,
  qa: undefined,
  className: undefined
};

/** @component */
export default Image;
